// extracted by mini-css-extract-plugin
module.exports = {"fuelPriceContainer":"_2cG9Y","fuelCardWrapper":"YqS9b","fuelCard":"qdXmE","price":"_3SV0e","fuelCardText":"_2qWmW","rupeesIcon":"_1TjNa"};